let language = {
    SELECT_ADDRESS_ADD_ADDRESS_TEXT: "Add Address",
    SELECT_ADDRESS_EDIT_ADDRESS_TEXT: "Edit Address",
    SELECT_ADDRESS_EMPTY_ADDRESS_TIP: "Your address book is empty. Please add address book first!",
    SELECT_ADDRESS_EDIT_BTN: "Edit",
    SELECT_ADDRESS_CANCEL_BTN: "Cancel",
    SELECT_ADDRESS_OK_BTN: "OK",
    SELECT_ADDRESS_ADD_BTN: "Add",
    SELECT_ADDRESS_SAVE_BTN: "Save",

    SELECT_ADDRESS_TEXT: "Select Address",
};

export { language }